let _baseURL: string | undefined;

export function setIdentityBaseURL(url: string) {
	_baseURL = url;
}

export function getIdentityBaseURL(): string {
	return _baseURL || import.meta.env.VITE_ACP_IDENTITY;
}
